import { render, staticRenderFns } from "./ProductAcqLimit.vue?vue&type=template&id=4745b6d3&scoped=true&"
import script from "./ProductAcqLimit.vue?vue&type=script&lang=js&"
export * from "./ProductAcqLimit.vue?vue&type=script&lang=js&"
import style0 from "./ProductAcqLimit.vue?vue&type=style&index=0&id=4745b6d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745b6d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
